import { render, staticRenderFns } from "./LoadersComponents.vue?vue&type=template&id=fe42ad92&"
import script from "./LoadersComponents.vue?vue&type=script&lang=js&"
export * from "./LoadersComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports